'use strict';

const urlHelper = require('../utils/urlHelper');

const SELECTORS = {
    body: 'body',
    activeAddToCartButton: '.ecom-buttons-container .active .js-add-to-cart-modal, .ecom-buttons-container .active .add-to-cart',
}

/**
 * Ajax request to 'Search-SetEventDate' endpoint to set date
 * @param url - url - Controller endpoint
 * @param selectedDate - Date to be set
 * @returns {void}
 */
function setDate(url, selectedDate) {
    url = urlHelper.appendToUrl(url, {
        date: selectedDate
    });

    var pageAction = $('.page').data('action');
    if (pageAction != null && pageAction.toLowerCase() == 'cart-show' || pageAction != null && pageAction.toLowerCase() == 'checkout-begin') {
        url = urlHelper.appendToUrl(url, {
            ischeckout: true
        });
    }

    var modalTrigger = $('.js-modal-trigger');
    if (modalTrigger.hasClass('js-minicart-link')) {
        url = urlHelper.appendToUrl(url, {
            iscart: true
        });
    }

    return $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success:  function (data) {
            $.spinner().stop();

            // Trigger add to cart if dom exists.
            if ($(SELECTORS.activeAddToCartButton).length > 0) {
                $(SELECTORS.activeAddToCartButton)
                    .removeClass('js-add-to-cart-modal js-modal-trigger')
                    .addClass('add-to-cart')
                    .trigger('click');
                return;
            }

            if (data.success && data.redirectUrl) {
                window.location = data.redirectUrl;
                return;
            }

            if (data.success) {
                window.location.reload();
            }
        }
    });
}

module.exports = {
    setDate: setDate,
}
